import SvgIcon, { type SvgIconProps } from 'LuxKit/SvgIcon'

function LineRowDoubleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fillRule="evenodd" clipRule="evenodd" d="M20 3C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H20ZM4 13V19H20V13H4ZM4 11H20V5H4V11Z" fill="currentColor" />
  </SvgIcon>
}

export default LineRowDoubleIcon
